export const maintenanceRepair = {
  maintenanceTemplate: "保养模板",
  templateItem: "项目",
  vehicleModel: "设备型号",
  modelsNumber: "匹配车型数",
  needApproval: "需审批",
  addMaintenanceTemplate: "新建保养模板",
  editMaintenanceTemplate: "编辑保养模板",
  pleaseInputMaintenanceTemplateName: "请输入保养模板名称",
  maintenanceTemplateDeleteTips: "保养模板{0}将被删除。确定要继续吗？",
  maintenanceTemplateName: "保养模板名称",
  deleteMaintenanceItemTip: "保养项“{0}”将被删除。确定要继续吗？",
  deleteMaintenanceGroupTip: "保养分组“{0}”将被删除。确定要继续吗？",
  failedToDeleteGroupNotEmpty: "删除失败，请先删除此分组的内容。",
  failedToDeleteItemUsed: "删除失败，此项目已被其他模板使用。",
  addRepair: "新建维修单",
  repairNumber: "维修单号",
  applicant: "申请人",
  applyDate: "申请时间",
  closeDate: "结案时间",
  status: "状态",
  operation: "操作",
  statusApplying: "审批中",
  statusCancel: "已撤销",
  statusApproval: "维保中",
  statusModify: "待补充",
  statusReject: "已驳回",
  statusDone: "已结案",
  approval: "审批",
  cancel: "撤销",
  repairContent: "维修项目",
  repairDescription: "问题描述",
  approvalRecord: "审批记录",
  approvalDate: "审批时间",
  approvalUserName: "审批人",
  approvalResult: "审批意见",
  approvalNote: "审批备注",
  repairRecord: "维修记录",
  repairer: "维修人",
  repairReport: "维修报告",
  repairDetail: "维修单详情",
  repairCancelTips: "维修单“{0}”将被撤销。确定要继续吗？",
  repairApproval: "维修单审批",
  pleaseInputRepairName: "请输入维修项目",
  qrCodeTips: "扫码打开微信小程序填写",
  editRepair: "编辑维修单",
  cancelSuccessfully: "撤销成功",
  approvalResultApproval: "同意",
  approvalResultModify: "补充材料",
  approvalResultReject: "驳回",
  addMaintenance: "新建保养单",
  maintenanceNumber: "保养单号",
  maintenanceItem: "保养项目",
  maintenanceRecord: "保养记录",
  maintainer: "保养人",
  maintenanceReport: "保养报告",
  maintenanceApproval: "保养单审批",
  editMaintenance: "编辑保养单",
  maintenanceDetail: "保养单详情",
  maintenanceCancelTips: "保养单“{0}”将被撤销。确定要继续吗？",
  vehicleIsInMaintenance: "当前设备正在保养中。",
  pleaseSelectVehicle: "请选择设备",
  pleaseSelectMaintenanceTemplate: "请选择保养模板",
  tipsMaintenanceItemsEmpty: "至少需要包含一个保养项目。",
  done: "结案",
  maxSizeImageTips: "最大支持{0}张图片",
  maintenanceHasCanceled: "保养单“{0}”已经被撤销",
  repairHasCanceled: "维修单“{0}”已经被撤销",
  maintenanceHasApproved: "保养单“{0}”已经被审批",
  repairHasApproved: "维修单已经被审批",
  maintenanceHasModified: "保养单正在审批中，无法修改",
  repairHasModified: "维修单正在审批中，无法修改",
  nextMaintenanceDate: "下一次保养日期",
  failedToDeleteTemplateUsed: "删除失败，模板({0})正在被使用中。",
  vehiclesIsInMaintenance: "设备{0}正在保养中。",
  batchApproval: "批量审批",
  batchMaintenance: "批量保养",
};
